import { commonSbEnv } from "./env.sb.common";

const env: Partial<typeof commonSbEnv> = {
  production: true,
  page: 'toate-produsele',
  pageCode: 'sbtp',
  meta: {
    siteTitle: 'Cursuri pentru libertate financiara prin investitii',
    siteDescription: 'Cuprinde, la nivel de incepator, toate tipurile de investitii: investitii pasive in actiuni, ETF-uri, imobiliare, obligatiuni, fonduri de investitii, crypto etc.',
    ogSiteName: 'Știința Banilor',
    ogUrl: 'https://stiintabanilor.ro/cursuri/lista/',
    // ogImage: 'https://stiintabanilor.ro/cursuri/lista/assets/images/toate-produsele/flash-sale-2026-inv-eficiente-fb.jpg',
    ogImage: 'https://stiintabanilor.ro/cursuri/lista/assets/images/toate-produsele/logo-sb-long.png',
    ogImageAlt: 'Cursuri pentru libertate financiara prin investitii'
  }
};

export const environment = { ...commonSbEnv, ...env };
